import { render, staticRenderFns } from "./Whitelabel.vue?vue&type=template&id=7d94a1fd"
import script from "./Whitelabel.vue?vue&type=script&lang=js"
export * from "./Whitelabel.vue?vue&type=script&lang=js"
import style0 from "./Whitelabel.vue?vue&type=style&index=0&id=7d94a1fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports